export default {
  placeholder: 'Select a language',
};
